var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload1BackgroundMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 774,
    height: 973,
    viewBox: "0 0 774 973",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_100_2660",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 774,
    height: 973
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 771,
    height: 970,
    rx: 51.5,
    fill: "#EBF5FF",
    fillOpacity: 0.3,
    stroke: "url(#paint0_linear_100_2660)",
    strokeWidth: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_100_2660)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_100_2660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M626.198 736.081C684.965 736.081 737.839 692.506 775.935 622.783C814.061 553.003 837.596 456.706 837.596 350.422C837.596 244.137 814.061 147.84 775.935 78.0605C737.839 8.33723 684.965 -35.238 626.198 -35.238C567.432 -35.238 514.557 8.33723 476.462 78.0605C438.336 147.84 414.801 244.137 414.801 350.422C414.801 456.706 438.336 553.003 476.462 622.783C514.557 692.506 567.432 736.081 626.198 736.081Z",
    fill: "#C1BCFF",
    stroke: "url(#paint1_linear_100_2660)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.259 825.055C207.025 825.055 259.9 781.48 297.995 711.757C336.121 641.977 359.656 545.68 359.656 439.396C359.656 333.111 336.121 236.814 297.995 167.034C259.9 97.3111 207.025 53.7358 148.259 53.7358C89.4923 53.7358 36.618 97.3111 -1.47744 167.034C-39.6036 236.814 -63.1387 333.111 -63.1387 439.396C-63.1387 545.68 -39.6036 641.977 -1.47744 711.757C36.618 781.48 89.4923 825.055 148.259 825.055Z",
    fill: "#C1BCFF",
    stroke: "url(#paint2_linear_100_2660)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.094 757.016C168.015 757.016 209.261 722.991 238.939 668.705C268.648 614.364 286.977 539.394 286.977 456.667C286.977 373.94 268.648 298.971 238.939 244.63C209.261 190.344 168.015 156.318 122.094 156.318C76.1724 156.318 34.9267 190.344 5.24852 244.63C-24.4603 298.971 -42.7891 373.94 -42.7891 456.667C-42.7891 539.394 -24.4603 614.364 5.24852 668.705C34.9267 722.991 76.1724 757.016 122.094 757.016Z",
    fill: "#FFD9DD",
    stroke: "url(#paint3_linear_100_2660)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.201 750.736C390.123 750.736 431.368 716.71 461.046 662.424C490.755 608.083 509.084 533.114 509.084 450.387C509.084 367.66 490.755 292.69 461.046 238.349C431.368 184.064 390.123 150.038 344.201 150.038C298.28 150.038 257.034 184.064 227.356 238.349C197.647 292.69 179.318 367.66 179.318 450.387C179.318 533.114 197.647 608.083 227.356 662.424C257.034 716.71 298.28 750.736 344.201 750.736Z",
    fill: "#DEB5FF",
    stroke: "url(#paint4_linear_100_2660)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.913 1008.24C244.821 1008.24 282.432 977.2 309.48 927.745C336.559 878.234 353.26 809.938 353.26 734.582C353.26 659.225 336.559 590.929 309.48 541.418C282.432 491.963 244.821 460.925 202.913 460.925C161.006 460.925 123.395 491.963 96.3467 541.418C69.2683 590.929 52.5664 659.225 52.5664 734.582C52.5664 809.938 69.2683 878.234 96.3467 927.745C123.395 977.2 161.006 1008.24 202.913 1008.24Z",
    fill: "#C173FF",
    stroke: "url(#paint5_linear_100_2660)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.339 896.235C344.246 896.235 381.858 865.197 408.906 815.742C435.984 766.231 452.686 697.934 452.686 622.578C452.686 547.222 435.984 478.926 408.906 429.415C381.858 379.959 344.246 348.921 302.339 348.921C260.432 348.921 222.82 379.959 195.772 429.415C168.694 478.926 151.992 547.222 151.992 622.578C151.992 697.934 168.694 766.231 195.772 815.742C222.82 865.197 260.432 896.235 302.339 896.235Z",
    fill: "#C173FF",
    stroke: "url(#paint6_linear_100_2660)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.72 813.541C657.539 813.541 703.218 775.883 736.105 715.726C769.023 655.512 789.337 572.431 789.337 480.743C789.337 389.055 769.023 305.973 736.105 245.76C703.218 185.602 657.539 147.944 606.72 147.944C555.902 147.944 510.223 185.602 477.335 245.76C444.417 305.973 424.104 389.055 424.104 480.743C424.104 572.431 444.417 655.512 477.335 715.726C510.223 775.883 555.902 813.541 606.72 813.541Z",
    fill: "#AAEBFF",
    stroke: "url(#paint7_linear_100_2660)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.118 548.712C171.085 548.712 195.692 517.977 195.692 480.743C195.692 443.509 171.085 412.774 140.118 412.774C109.151 412.774 84.5449 443.509 84.5449 480.743C84.5449 517.977 109.151 548.712 140.118 548.712Z",
    fill: "#FFDA58",
    stroke: "url(#paint8_linear_100_2660)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.118 523.589C171.085 523.589 195.692 492.855 195.692 455.62C195.692 418.386 171.085 387.651 140.118 387.651C109.151 387.651 84.5449 418.386 84.5449 455.62C84.5449 492.855 109.151 523.589 140.118 523.589Z",
    fill: "#FFDD65",
    stroke: "url(#paint9_linear_100_2660)",
    strokeWidth: 3
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_100_2660",
    x: -348.229,
    y: -320.329,
    width: 1470.92,
    height: 1613.66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 141.795,
    result: "effect1_foregroundBlur_100_2660"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_100_2660",
    x1: 771,
    y1: 3,
    x2: -199.584,
    y2: 293.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_100_2660",
    x1: 626.198,
    y1: -33.738,
    x2: 626.198,
    y2: 734.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_100_2660",
    x1: 148.259,
    y1: 55.2358,
    x2: 148.259,
    y2: 823.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_100_2660",
    x1: 122.094,
    y1: 157.818,
    x2: 122.094,
    y2: 755.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_100_2660",
    x1: 344.201,
    y1: 151.538,
    x2: 344.201,
    y2: 749.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_100_2660",
    x1: 202.913,
    y1: 462.425,
    x2: 202.913,
    y2: 1006.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_100_2660",
    x1: 302.339,
    y1: 350.421,
    x2: 302.339,
    y2: 894.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_100_2660",
    x1: 606.72,
    y1: 149.444,
    x2: 606.72,
    y2: 812.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_100_2660",
    x1: 140.118,
    y1: 414.274,
    x2: 140.118,
    y2: 547.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_100_2660",
    x1: 140.118,
    y1: 389.151,
    x2: 140.118,
    y2: 522.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload1BackgroundMedium);
export default __webpack_public_path__ + "static/media/download-1-background-medium.a42d172e5e9bb8a2344a10f08afe83fe.svg";
export { ForwardRef as ReactComponent };